if (typeof AddOnsKit !== 'function') {
    class AddOnsKit extends HTMLElement {
        constructor() {
            super();

            this.buttonAdd = this.querySelectorAll('[data-add-to-car]');
            this.buttonRemove = this.querySelector('[data-button-remove]');

            this.buttonRemove.addEventListener('click', (e) => {
                e.preventDefault();
                const datafor = this.buttonRemove.getAttribute('data-for');
                const allInputs = document.querySelectorAll(`input[data-for="${datafor}"]`);
                allInputs.forEach(ele => {
                    ele.remove();
                })
                this.querySelector('[data-add-to-car]').classList.remove('active');
                this.buttonRemove.classList.remove('active');
                this.getFinalPrice();
            });

            if (this.buttonAdd) {
                this.buttonAdd.forEach(button => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        if (!button.classList.contains('soldout')) {
                            const productIde = button.getAttribute('data-value');
                            const datafor = button.getAttribute('data-for');
                            let dataP = button.getAttribute("data-seek");
                            if (!button.classList.contains('active')) {
                                const allInputs = document.querySelectorAll(`input[data-for="${datafor}"]`);
                                allInputs.forEach(ele => {
                                    ele.remove();
                                })
                                button.classList.add('active');
                                this.buttonRemove.classList.add('active');

                                if (dataP === null) {
                                    dataP = 0;
                                }
                                this.handleAddAddons(productIde, datafor, dataP);
                            } else {
                                const allInputs = document.querySelectorAll(`input[data-for="${datafor}"]`);
                                allInputs.forEach(ele => {
                                    ele.remove();
                                })
                                button.classList.remove('active');
                                this.buttonRemove.classList.remove('active');
                                this.getFinalPrice();
                            }
                        }
                    })
                })
            }



        }

        handleAddAddons(ide, datafor, dataP) {
            if (ide) {
                //Sticky form
                const element = document.createElement('input');
                element.value = ide;
                element.type = 'hidden';
                element.name = 'id';
                element.setAttribute('data-for', datafor);
                element.setAttribute("data-seek", dataP)
                element.classList.add = 'addon_input';
                element.setAttribute('data-quantity', 1);
                const formContent = document.getElementById('bulk-add-to-cart');
                formContent.append(element);

                const dataMix = document.querySelector('input[data-for="gummy-mixer-addon"]');

                if(dataMix) {
                    dataMix.remove();
                    const optionMixer = document.querySelectorAll('div[data-for="gummy-mixer-addon"]');
                    optionMixer.forEach(elem =>  {
                        elem.classList.remove('active');
                    });

                    document.querySelector('div[data-for="gummy-mixer-addon"]:last-child').classList.add('active');
                }

            } else {
                document.querySelector(`input[data-for="${datafor}"]`)?.remove();
            }
            this.getFinalPrice();
        }

        getFinalPrice() {
            const elementsForm = document.querySelectorAll('input[data-seek]');
            let total = 0;
            elementsForm.forEach((e) => {
                if (e.getAttribute("data-seek") && e.getAttribute("data-seek") !== null) {
                    total += Number(e.getAttribute("data-seek"));
                }
            })
            const formattedNumber = (total / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
            document.getElementById('total_buy').innerHTML = formattedNumber;
            document.querySelectorAll('.total_buy_button').forEach((button) => {
                button.innerHTML = formattedNumber;
            });
        }


    }

    if (typeof customElements.get('addon-kit') == 'undefined') {
        customElements.define('addon-kit', AddOnsKit);
    }
}
